import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import './../../styles/cliente/renovacion.css';
import * as globals from '../../components/GlobalScripts.js';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { Link, useNavigate, useLocation } from 'react-router-dom';

function dateOnly(d) {
    return String(d || '').slice(0, 10);
}
function getTodayEc() {
    return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Guayaquil' });
}
function money2(n) {
    const v = Number(n || 0);
    if (!isFinite(v)) return '0.00';
    return v.toFixed(2);
}

function parseAmount(any) {
    if (any == null) return null;
    if (typeof any === 'number') return isFinite(any) ? any : null;

    const s0 = String(any).trim();
    if (!s0) return null;

    let s = s0.replace(/[^\d.,-]/g, '');

    if (s.includes(',') && !s.includes('.')) {
        s = s.replace(',', '.');
    } else if (s.includes(',') && s.includes('.')) {
        s = s.replace(/,/g, '');
    }

    const v = Number(s);
    return isFinite(v) ? v : null;
}

function calcFromCouponForAmount(couponResult, amount) {
    const base = Number(amount || 0);
    if (!couponResult || !isFinite(base) || base <= 0) {
        return { subtotal: base, descuento: 0, total_final: base, percent: null };
    }

    const tipo = String(couponResult?.cupon?.tipo_descuento || '');
    const valor = Number(couponResult?.cupon?.valor || 0);

    if (tipo === 'percent' && isFinite(valor) && valor > 0) {
        const desc = Math.round((base * (valor / 100)) * 100) / 100;
        const tot = Math.round((base - desc) * 100) / 100;
        return { subtotal: base, descuento: desc, total_final: tot, percent: valor };
    }

    if (tipo === 'fixed' && isFinite(valor) && valor > 0) {
        const desc = Math.round(Math.min(valor, base) * 100) / 100;
        const tot = Math.round((base - desc) * 100) / 100;
        return { subtotal: base, descuento: desc, total_final: tot, percent: null };
    }

    return { subtotal: base, descuento: 0, total_final: base, percent: null };
}

const Cliente_renovacion = () => {
    const path_api = localStorage.getItem('path_api');
    const location = useLocation();
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [step, setStep] = useState(1);
    const [niveles, setNiveles] = useState([]);
    const [formDataMembership, setFormDataMembership] = useState({ id: '' });

    const hoy = useMemo(() => getTodayEc(), []);

    const [couponCode, setCouponCode] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponErr, setCouponErr] = useState('');
    const [couponResult, setCouponResult] = useState(null);
    const autoApplyRef = useRef(false);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            const userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }
        get_niveles();
    }, []);

    useEffect(() => {
        const sp = new URLSearchParams(location.search || '');
        const q = sp.get('cupon');
        if (q && !couponCode) {
            setCouponCode(String(q));
            autoApplyRef.current = true;
        }
    }, [location.search]);

    useEffect(() => {
        if (!niveles?.length) return;
        if (formDataMembership.id) return;

        const first = niveles.find((n) => Number(n?.id) !== 0);
        if (first?.id != null) setFormDataMembership({ id: user?.membership?.id ?? String(first.id) });
    }, [niveles, formDataMembership.id]);

    const envios = Number(user?.envios || 0);
    const expDay = dateOnly(user?.envios_expira_at);

    const isExpired = !!(expDay && expDay < hoy);
    const canRenew = envios === 0 || isExpired;

    const selectedMembership = useMemo(() => {
        const id = String(formDataMembership.id || '');
        return niveles.find((n) => String(n?.id) === id) || null;
    }, [niveles, formDataMembership.id]);

    const subtotalPayPal = useMemo(() => {
        return Number(selectedMembership?.precio || 0) || 0;
    }, [selectedMembership]);

    const subtotalTransfer = useMemo(() => {
        const v = parseAmount(selectedMembership?.precio_label);
        if (v == null) return Number(selectedMembership?.precio || 0) || 0;
        return v;
    }, [selectedMembership]);

    const totalFinalPayPal = useMemo(() => {
        const tf = Number(couponResult?.calc?.total_final);
        if (couponResult && isFinite(tf) && tf > 0) return tf;
        return subtotalPayPal;
    }, [couponResult, subtotalPayPal]);

    const descuentoPayPal = useMemo(() => {
        const d = Number(couponResult?.calc?.descuento);
        if (couponResult && isFinite(d) && d > 0) return d;
        return 0;
    }, [couponResult]);

    const transferCalc = useMemo(() => {
        return calcFromCouponForAmount(couponResult, subtotalTransfer);
    }, [couponResult, subtotalTransfer]);

    const percentValue = useMemo(() => {
        const t = String(couponResult?.cupon?.tipo_descuento || '');
        if (t === 'percent') {
            const v = Number(couponResult?.cupon?.valor || 0);
            return isFinite(v) && v > 0 ? v : null;
        }
        return null;
    }, [couponResult]);

    const get_niveles = () => {
        axios.post(`${path_api}/default/niveles.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setNiveles(response.data.niveles || []);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los niveles",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(() => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar niveles",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleChange_Membership = (e) => {
        setFormDataMembership({ id: String(e.target.value) });
    };

    const validateCoupon = async ({ code, silent = false } = {}) => {
        const raw = String(code ?? couponCode ?? '');
        const c = raw.trim();

        setCouponErr('');
        setCouponResult(null);

        if (!c) {
            if (!silent) setCouponErr('Ingresa un cupón.');
            return;
        }
        if (!selectedMembership || subtotalPayPal <= 0) {
            if (!silent) setCouponErr('Primero selecciona un plan válido.');
            return;
        }

        setCouponLoading(true);
        try {
            const res = await axios.post(`${path_api}/default/cupones/validar.php`, {
                rute: globals.getRuteBackend?.(),
                session_id: globals.get_session_id?.(),
                keylogin: globals.get_keylogin?.(),
                codigo: c,
                subtotal: subtotalPayPal,
                moneda: 'USD',
                membership: selectedMembership,
            });

            if (res.data?.mensaje !== 'success') {
                setCouponErr(String(res.data?.mensaje || 'Cupón inválido'));
                setCouponResult(null);
                return;
            }

            setCouponResult({
                cupon: res.data?.cupon || null,
                calc: res.data?.calc || null,
            });

            const returnedCode = res.data?.cupon?.codigo ? String(res.data.cupon.codigo) : c;
            setCouponCode(returnedCode);

            if (!silent) {
                globals.createAlert?.({
                    type: "success",
                    msg_title: "Cupón aplicado",
                    msg: "Se aplicó el descuento correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 2500
                });
            }
        } catch (e) {
            setCouponErr(String(e?.message || 'Error al validar cupón'));
            setCouponResult(null);
        } finally {
            setCouponLoading(false);
        }
    };

    useEffect(() => {
        setCouponErr('');
        setCouponResult(null);
        if (couponCode.trim()) autoApplyRef.current = true;
    }, [formDataMembership.id]);

    useEffect(() => {
        if (!autoApplyRef.current) return;
        if (!selectedMembership || subtotalPayPal <= 0) return;
        if (!couponCode.trim()) return;

        autoApplyRef.current = false;
        validateCoupon({ code: couponCode, silent: true });
    }, [selectedMembership?.id, subtotalPayPal]);

    const clearCoupon = () => {
        setCouponCode('');
        setCouponErr('');
        setCouponResult(null);
    };

    const handleSubmit_Membership = (e) => {
        e.preventDefault();

        if (!selectedMembership) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Selecciona un plan válido",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            return;
        }

        if (!canRenew) {
            globals.createAlert({
                type: "error",
                msg_title: "No disponible",
                msg: "Solo puedes renovar si tu plan ya expiró o si no tienes envíos.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4500
            });
            return;
        }

        setStep(2);
    };

    const updateMembership = async (order) => {
        globals.openViewCharge();
        try {
            const res = await axios.post(`${path_api}/update-clients/membership.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                membership: selectedMembership,
                payment: order,
                coupon_code: couponResult?.cupon ? String(couponCode || couponResult?.cupon?.codigo || '') : '',
            });

            if (res.data.mensaje === "success") {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La renovación se procesó con éxito.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });

                localStorage.setItem('user', JSON.stringify(res.data.user));
                setUser(res.data.user);
                setStep(1);
                clearCoupon();

                navigate('/cliente/menu');
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data.mensaje || "Error al procesar tu renovación",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4500
            });

        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error al conectar con el servidor",
                msg: "Si persiste informa al soporte",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4500
            });
        } finally {
            globals.closeViewCharge();
        }
    };

    const initialOptions = {
        "client-id": "AYd9c1Wq2pIUbaOfEkmhPlX3mfraLosnx3yvGjMzcV2iVkR8GYfeBpmlBKWjvD_QKsXtLXwkhmuJrKsD",
        //"client-id": "AUSodq5gbZZSSKD7ihnLFDHPFSliQapDWC2lWsLB59SKujMxh0naRjc8IdP-V57rcYz44n_CSjhAFH0c",
        currency: 'USD',
        intent: "capture",
    };

    const handleReturn = (e) => {
        e.preventDefault();
        setStep(1);
    };

    return (
        <div className='page-renovacion container-section medium-section flex-column gap-20'>
            <div className="flex-column gap-8">
                <h3>Renovación</h3>

                <p><b>Envíos disponibles:</b> {envios}</p>
                <p><b>Expira:</b> {expDay ? expDay : '—'}</p>

                {!canRenew && (
                    <p className='text-red'>
                        No puedes renovar aún. Solo puedes renovar si tu plan <b>ya expiró</b> o si <b>no tienes envíos</b>.
                    </p>
                )}

                {isExpired && envios > 0 && (
                    <p className='text-red'>
                        Tienes envíos, pero tu plan está <b>vencido</b>. Puedes renovar para reactivar tu plan (no conservarás los envios vencidos).
                    </p>
                )}
            </div>

            {step === 1 && (
                <form onSubmit={handleSubmit_Membership} className="flex-column gap-20">
                    <div className="form-grop-row">
                        <div className="form-group">
                            <label htmlFor="id">Tipos de servicio:</label>
                            <select
                                id="id"
                                name="id"
                                value={formDataMembership.id}
                                onChange={handleChange_Membership}
                                className="input-primary"
                                required
                            >
                                {niveles
                                    .filter((n) => Number(n?.id) !== 0)
                                    .map((nivel) => (
                                        <option key={nivel.id} value={nivel.id}>
                                            {nivel.descripcion}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>¿Qué obtendrás?: <p>{selectedMembership?.beneficios || '—'}</p></label>

                            <label>
                                Precio PayPal:
                                <p>
                                    {selectedMembership?.precio != null ? (
                                        couponResult ? (
                                            <span className="ren-price">
                                                <span className="ren-price__old">${money2(subtotalPayPal)} USD</span>
                                                <span className="ren-price__new">${money2(totalFinalPayPal)} USD</span>
                                                {percentValue != null ? (
                                                    <span className="ren-price__pill">(-{percentValue}% = -${money2(descuentoPayPal)})</span>
                                                ) : (
                                                    <span className="ren-price__pill">(-${money2(descuentoPayPal)})</span>
                                                )}
                                            </span>
                                        ) : (
                                            `$${money2(subtotalPayPal)} USD`
                                        )
                                    ) : '—'}
                                </p>
                            </label>

                            <label>
                                Precio transferencia:
                                <p>
                                    {selectedMembership?.precio_label != null ? (
                                        couponResult ? (
                                            <span className="ren-price ren-price--transfer">
                                                <span className="ren-price__old">${money2(transferCalc.subtotal)} USD</span>
                                                <span className="ren-price__new">${money2(transferCalc.total_final)} USD</span>
                                                {percentValue != null ? (
                                                    <span className="ren-price__pill">(-{percentValue}% = -${money2(transferCalc.descuento)})</span>
                                                ) : (
                                                    <span className="ren-price__pill">(-${money2(transferCalc.descuento)})</span>
                                                )}
                                            </span>
                                        ) : (
                                            (() => {
                                                const v = parseAmount(selectedMembership?.precio_label);
                                                return v == null ? String(selectedMembership?.precio_label) : `$${money2(v)} USD`;
                                            })()
                                        )
                                    ) : '—'}
                                </p>
                            </label>
                        </div>
                    </div>

                    <div className="ren-cpn">
                        <div className="ren-cpn__head">
                            <div>
                                <div className="ren-cpn__title">¿Tienes un cupón?</div>
                                <div className="ren-cpn__sub">Opcional: aplícalo para obtener descuento.</div>
                            </div>
                            <div className="ren-cpn__badge">Cupón</div>
                        </div>

                        <div className="ren-cpn__row">
                            <input
                                className="input-primary ren-cpn__input"
                                value={couponCode}
                                onChange={(e) => {
                                    setCouponCode(e.target.value);
                                    setCouponErr('');
                                    setCouponResult(null);
                                }}
                                placeholder="Escribe tu cupón…"
                                autoComplete="off"
                                disabled={couponLoading}
                            />

                            <button
                                type="button"
                                className="button-primary ren-cpn__apply"
                                onClick={() => validateCoupon({ code: couponCode, silent: false })}
                                disabled={couponLoading || !couponCode.trim() || !selectedMembership || subtotalPayPal <= 0}
                            >
                                {couponLoading ? 'Validando…' : 'Aplicar'}
                            </button>

                            {(couponCode.trim() || couponResult) ? (
                                <button
                                    type="button"
                                    className="button-secondary ren-cpn__clear"
                                    onClick={clearCoupon}
                                    disabled={couponLoading}
                                >
                                    Quitar
                                </button>
                            ) : null}
                        </div>

                        {couponErr ? (
                            <div className="ren-cpn__alert ren-cpn__alert--error">{couponErr}</div>
                        ) : null}

                        {couponResult ? (
                            <div className="ren-cpn__summary">
                                <div className="ren-cpn__sumrow">
                                    <span>Subtotal PayPal</span>
                                    <b>${money2(subtotalPayPal)} USD</b>
                                </div>

                                <div className="ren-cpn__sumrow">
                                    <span>
                                        Descuento {percentValue != null ? `(-${percentValue}%)` : ''}
                                    </span>
                                    <b>- ${money2(descuentoPayPal)} USD</b>
                                </div>

                                <div className="ren-cpn__sumrow ren-cpn__sumrow--total">
                                    <span>Total PayPal</span>
                                    <b>${money2(totalFinalPayPal)} USD</b>
                                </div>

                                <div className="ren-cpn__hint">
                                    Cupón aplicado: <b>{String(couponResult?.cupon?.codigo || couponCode)}</b>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    <div className="buttons-opt">
                        <button
                            className="button-primary"
                            type="submit"
                            disabled={!selectedMembership || !canRenew || couponLoading}
                            title={couponLoading ? 'Espera a que termine la validación del cupón' : ''}
                        >
                            Pagar
                        </button>
                    </div>
                </form>
            )}

            {step === 2 && (
                <div className="container-section small-section flex-column gap-20">
                    <PayPalScriptProvider options={initialOptions}>
                        <Link onClick={handleReturn} className="flex-row gap-5">
                            <h4 style={{ color: "var(--color-primary)" }}>Volver</h4>
                        </Link>

                        <h3>Realiza el pago</h3>

                        <div className="ren-pay-summary">
                            <div className="ren-pay-summary__row">
                                <span>Plan</span>
                                <b>{String(selectedMembership?.descripcion || 'Renovación')}</b>
                            </div>

                            <div className="ren-pay-summary__row">
                                <span>Subtotal</span>
                                <b>${money2(subtotalPayPal)} USD</b>
                            </div>

                            {couponResult ? (
                                <>
                                    <div className="ren-pay-summary__row">
                                        <span>Descuento {percentValue != null ? `(-${percentValue}%)` : ''}</span>
                                        <b>- ${money2(descuentoPayPal)} USD</b>
                                    </div>
                                    <div className="ren-pay-summary__row ren-pay-summary__row--total">
                                        <span>Total</span>
                                        <b>${money2(totalFinalPayPal)} USD</b>
                                    </div>
                                </>
                            ) : (
                                <div className="ren-pay-summary__row ren-pay-summary__row--total">
                                    <span>Total</span>
                                    <b>${money2(totalFinalPayPal)} USD</b>
                                </div>
                            )}
                        </div>

                        <PayPalButtons
                            style={{ layout: "vertical" }}

                            onClick={(data, actions) => {
                                const enviosNow = Number(user?.envios || 0);
                                const expNow = dateOnly(user?.envios_expira_at);
                                const canRenewNow = enviosNow === 0 || (expNow && expNow < hoy);

                                if (!canRenewNow) {
                                    globals.createAlert({
                                        type: "error",
                                        msg_title: "No disponible",
                                        msg: "Tu plan aún está vigente. No puedes renovar todavía.",
                                        effect: "opacidad 2s, desplazamiento 2s",
                                        time_life: 4500,
                                    });
                                    return actions.reject();
                                }
                                return actions.resolve();
                            }}

                            createOrder={(data, actions) => {
                                return actions.order.create({
                                    purchase_units: [{
                                        amount: {
                                            currency_code: 'USD',
                                            value: money2(totalFinalPayPal),
                                        },
                                        description: couponResult
                                            ? `${String(selectedMembership?.descripcion || 'Renovación')} (Cupón: ${String(couponResult?.cupon?.codigo || couponCode || '').trim()})`
                                            : String(selectedMembership?.descripcion || 'Renovación'),
                                    }],
                                });
                            }}

                            onApprove={(data, actions) => {
                                return actions.order.capture().then((details) => {
                                    updateMembership(details);
                                });
                            }}

                            onError={() => {
                                globals.createAlert({
                                    type: "error",
                                    msg_title: "Error",
                                    msg: "Hubo un error al procesar el pago",
                                    effect: "opacidad 2s, desplazamiento 2s",
                                    time_life: 4500,
                                });
                            }}
                        />
                    </PayPalScriptProvider>

                    <div className='transfer-opt'>
                        <h4>Ó realiza una transferencia por {money2(transferCalc.total_final)} USD</h4>
                        <p>Banco: <b>Pichincha</b></p>
                        <p><b>Cuenta de ahorro</b></p>
                        <p>Número: <b>2208487691</b></p>
                        <p><b>David Galarraga</b></p>
                        <p>CI: <b>1723000905</b></p>
                        <p><b>david_caspian99@hotmail.com</b></p>

                        {couponResult ? (
                            <div className="ren-transfer-note">
                                Cupón aplicado también a transferencia:{" "}
                                <b>{String(couponResult?.cupon?.codigo || couponCode)}</b>
                                {percentValue != null
                                    ? ` (-${percentValue}% = -$${money2(transferCalc.descuento)})`
                                    : ` (-$${money2(transferCalc.descuento)})`}
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cliente_renovacion;
